<template>
  <StockCompare>
    <div class="stockview-dashboard">
      <div class="columns is-desktop">
        <div class="column">
          <StockCompareStats :primary="true" />
        </div>
        <div class="column">
          <StockCompareStats :primary="false" />
        </div>
      </div>
      <StockCompareDashboardCharts />
    </div>
  </StockCompare>
</template>

<script>
export default {
  name: 'StockCompareDashboard',
  components: {
    StockCompare: () => import('./StockCompare'),
    StockCompareStats: () => import('../components/StockCompareStats'),
    StockCompareDashboardCharts: () =>
      import('../components/StockCompareDashboardCharts')
  }
}
</script>

<style lang="sass">
.card-header
  background: $white
</style>
